import { LoggerInit } from './LoggerInit';

export { logger, logTagError, logTagInfo, Tag } from './logger';
export { LoggerInit };
